import { PartAlternative } from '@luminovo/http-client';

export const partAlternativesIdExtractor = (rowData: PartAlternative): string => {
    return rowData.off_the_shelf_part.id;
};
